<script setup>
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { gql } from "@apollo/client/core";
import apolloClient from "@/apollo";

import SidenavItem from "./SidenavItem.vue";

const store = useStore();
const router = useRouter();

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

// GraphQL Logout Mutation
const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout
  }
`;

// Handle logout
const handleLogout = async () => {
  try {
    await apolloClient.mutate({
      mutation: LOGOUT_MUTATION,
    });
  } catch (error) {
    console.error("Logout error:", error);
  }

  // Clear cookie
  document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  // Clear localStorage for user
  localStorage.removeItem("user");

  // Clear Vuex store
  store.state.user = null;
  store.state.isAuthenticated = false;

  // Redirect to signin
  router.push("/login");
};
</script>
<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/tableau-de-bord"
          :class="getRoute() === 'tableau de bord' ? 'active' : ''"
          navText="Tableau de bord"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/maisons-dhotes"
          :class="getRoute() === 'maisons-dhotes' ? 'active' : ''"
          navText="Maisons d'hôtes"
        >
          <template v-slot:icon>
            <i
              class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/circuits-d-excursion"
          :class="getRoute() === 'circuits-d-excursion' ? 'active' : ''"
          navText="Circuits d'excursion"
        >
          <template v-slot:icon>
            <i class="ni ni-world text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/campements"
          :class="getRoute() === 'campements' ? 'active' : ''"
          navText="Campements"
        >
          <template v-slot:icon>
            <i class="ni ni-app text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/reservations"
          :class="getRoute() === 'reservations' ? 'active' : ''"
          navText="Réservations"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
     <!--
      <li class="nav-item">
        <sidenav-item
          to="/paiements"
          :class="getRoute() === 'paiements' ? 'active' : ''"
          navText="Paiements"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      -->
    </ul>
  </div>

  <div class="pt-3 mx-1000 mt-3 sidenav-footer">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" @click="handleLogout" style="cursor: pointer;">
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">Se déconnecter</span>
        </a>
      </li>
    </ul>
  </div>

   
</template>
